export const formSubmitSuccessMsg = "Form data submitted succesfully!";
export const formUpdateSuccessMsg = "Form data updated succesfully!";
export const somethingWentWrongMsg = "Something went wrong!";
export const formActiveMsg = "Form activated successfully!";
export const formDeActiveMsg = "Form de-activated successfully!";
export const logoValidMsg = "Logo link is not a valid url!";
